import { iframePush } from 'core/iframe';
import { CONFIG } from 'config';

export function Startup(props) {
    const { search } = window.location;
    iframePush(`${CONFIG.appLinks.startup}${search}`, '/home')();
    return null;
}
export default Startup;
